<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="modal.open"
    class="modal-alert"
  >
    <div class="page-content">
      <section class="content">
        <h5
          :class="{
            'text-danger': error,
            'text-success': success,
          }"
        >
          <i
            :class="{
              'el-icon-warning': error,
              'el-icon-success': success,
            }"
            class="el-icon-info"
          >
          </i>
          <span>
            {{ head ? head : error ? "ผิดพลาด" : success ? "สำเร็จ" : "N/A" }}
          </span>
        </h5>
        <slot name="body"></slot>
        <div v-if="title || message">
          <p v-if="title">
            <b>
              {{ title }}
            </b>
          </p>
          <p v-if="message">
            {{ message }}
          </p>
        </div>
      </section>
      <section class="footer">
        <el-button
          v-if="cancel"
          type="info"
          @click="() => (modal.open = false)"
        >
          ยกเลิก
        </el-button>
        <el-button
          :type="error ? 'danger' : 'success'"
          :disabled="disabled"
          @click="() => confirm()"
        >
          ตกลง
        </el-button>
      </section>
    </div>
  </el-dialog>
</template>

<script lang="js">
export default {
  props: {
    open: Boolean,
    head: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    message: {
      type: String,
      default: undefined,
    },
    disabled: Boolean,
    cancel: Boolean,
  },
  data() {
    return {
      modal: {
        open: false,
      },
    }
  },
  computed: {
    success() {
      return this.type === "success"
    },
    error() {
      return this.type === "error"
    },
  },
  watch: {
    open(value) {
      this.modal.open = value
    },
    "modal.open": function modalOpenWatcher(value) {
      if (!value) this.$emit("closed")
    },
  },
  mounted() {
    this.modal.open = this.open
  },
  methods: {
    confirm() {
      // Set Modal
      this.modal.open = false

      // Emit Confirm Event
      this.$emit("confirm")
    },
  },
}
</script>

<style lang="css" scoped>
.modal-alert >>> .el-dialog {
  max-width: 420px;
}
.modal-alert >>> .el-dialog__header {
  padding: 0;
}
.page-content {
  padding: var(--size-lg);
  gap: var(--size-sm);
}
.page-content .content {
  display: flex;
  gap: var(--size-sm);
  flex-direction: column;
  align-items: flex-start;
}
.page-content .content h5 {
  margin: 0;
}
.el-dialog__header {
  display: none;
}
.footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--size-sm);
}
</style>
